export default {"src":"/_next/static/media/selector-icon.9ed4ee40.svg","height":8,"width":14};